import type {
  VehicleFeatures,
  MappedVehicleFeatures,
} from 'components/PageWrappers/AdDetails/components/VehicleFeatures/VehicleFeatures.typed';

const mapVehicleFeatures = (
  features: VehicleFeatures,
): MappedVehicleFeatures[] =>
  Object.entries(features).map(([category, features]) => ({
    category,
    features,
  }));

export { mapVehicleFeatures };
